import flow from 'lodash/flow';
import { withMedia } from 'react-media-query-hoc';
import { withAllhomesContext } from '@domain-group/fe-co-allhomes-global-context';
var pageWrapper = function pageWrapper() {
  for (var _len = arguments.length, additional = new Array(_len), _key = 0; _key < _len; _key++) {
    additional[_key] = arguments[_key];
  }
  return flow(...additional, withAllhomesContext('inspections', 'isInInspectionPlan'), withMedia);
};
export default pageWrapper;